<style>
#HistoryChangesDetails .v--modal-box.v--modal {
  min-height: 335px !important;
  min-width: 400px !important;
}
#HistoryChangesDetails *:not(.v-icon) {
  font-size: 12px;
}
#HistoryChangesDetails .v-input {
  pointer-events: none;
}
</style>

<template>
  <Modal
    modalName="HistoryChangesDetails"
    title="Szczegóły zmiany"
    @closed="close"
    :buttons="[]"
  >
    <v-layout v-if="currentChange.hasOwnProperty('id')">
      <v-flex xs5>
        <v-text-field
          label="Identyfikator"
          v-model="currentChange.id"
        ></v-text-field>
      </v-flex>
      <v-spacer />
      <v-flex xs5>
        <v-text-field
          label="Czas zmiany"
          v-if="currentChange.hasOwnProperty('index')"
          v-model="currentChange.index.time"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs5>
        <v-text-field
          label="Użytkownik"
          v-if="currentChange.hasOwnProperty('index')"
          v-model="currentChange.index.username"
        ></v-text-field>
      </v-flex>
      <v-spacer />
    </v-layout>
    <v-layout>
      <SingleChangeTable :currentChange="currentChange" />
    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import SingleChangeTable from "../../table/history/SingleChangeTable";

export default {
  components: {
    Modal,
    SingleChangeTable
  },
  data: () => ({
    currentChange: {}
  }),
  methods: {
    historyDetailLoaded(data) {
      data.index.time = new Date(data.index.time).toLocaleString("pl-PL", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
      this.currentChange = data;
      this.$root.$emit("refreshSingleChangeGrid", data);
    },
    close() {
      this.currentChange = {};
    }
  },
  mounted() {
    this.$root.$on("historyDetailLoaded", this.historyDetailLoaded);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/HistoryChangesDetails.vue